<template>
    <div >

        <my-table :data="tableData" >
            <el-table-column label="导航" prop="name" >
                 <template slot-scope="scope">
                    <div >
                        <el-button type="text" @click="goto({ path:scope.row.path})">
                            {{scope.row.name}}
                        </el-button>
                    </div>
                </template>
            </el-table-column>
             <el-table-column label="操作" >
             <template slot-scope="scope">
                <div >
                    <el-button type="text" @click="goto({ path:scope.row.path})">
                        进入
                    </el-button>
                </div>
            </template>
            </el-table-column> 
        </my-table>
        <el-button icon="el-icon-circle-check" type="primary" @click="gokzt()" style="margin-top:30px;margin-left: 43%;" >
            进入控制台(项目列表)
        </el-button>
        <my-dialog title="控制台(项目列表)" v-model="dialogVisible" width="1150px" >
            <xmList v-if="dialogVisible"></xmList>
        </my-dialog>
    </div>
</template>

<script>
import xmList from './xmList'
export default {
    // mixins: [LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    components: { xmList },
    data() {
        return{
            tableData:[
                { name:'项目退回',path:'/manage/business/back/backprojectth/list'},
                { name:'招标项目退回',path:'/manage/business/back/backzbxmth/list'},
                { name:'标段退回',path:'/manage/business/back/backbdth/list'},
                { name:'招标文件退回',path:'/manage/business/back/backzbwjth/list'},
                { name:'开标记录退回',path:'/manage/business/back/backkbjlth/list'},
                { name:'二信封开标记录退回',path:'/manage/business/back/backexfkbjlth/list'},
                { name:'资格审查退回',path:'/manage/business/back/backzgscth/list'},
                { name:'评标报告退回',path:'/manage/business/back/backpbbgth/list'},
                { name:'定标报告退回',path:'/manage/business/back/backdbbgth/list'},
                { name:'中标候选人退回',path:'/manage/business/back/backzbhxrth/list'},
                { name:'招标公告退回(不推送其他平台)',path:'/manage/business/back/backzbggth/list'},
                { name:'中标候选人公示退回(不推送其他平台)',path:'/manage/business/back/backzbhxrgsth/list'},
                { name:'中标公告退回(不推送其他平台)',path:'/manage/business/back/backzhongbggth/list'},
            ],
            dialogVisible:false
        }
    },
    computed: {
        
    },
    watch: {
    
    },
    methods: {
        gokzt() {
            this.dialogVisible=true
        },
        gokz() {
            
            this.goto({
                path: './kongzhitai',
                // query: {
                //     zbprocode: zbprocode,
                // }
            });
        }
    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
